import PageHeader from "@/components/shared/PageHeader";

export default function Privacy() {
  return (
    <>
      <PageHeader overline="Legal" title="Privacy statement." />
      <section className="ccdr-section">
        <div className="ccdr-narrow ccdr-prose">
          <p className="ccdr-lead">
            The Centre for Climate and Disaster Resilience (CCDR) takes privacy seriously. This statement explains
            what personal information the Centre collects through this website, how it is used, and the rights of the
            individuals whose data is held.
          </p>
          <h2 className="ccdr-h3 mt-12 mb-4">Information collected</h2>
          <p>
            The Centre collects information you provide voluntarily through the contact form,
            including your name, email address, organisation, and the contents of any message or attached file.
            Server logs may also record technical information such as IP address and browser type for security purposes.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">How information is used</h2>
          <p>
            Information is used to respond to enquiries and improve the service. The Centre does not sell personal data and uses third-party processors only where necessary for email delivery and analytics.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">Your rights</h2>
          <p>
            You may request access to, correction of, or deletion of personal data the Centre holds about you at any
            time by writing to the Centre. The Centre will respond within a reasonable period.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">Contact</h2>
          <p>For privacy enquiries, please use the contact form on the Get Involved page.</p>
          <p className="text-sm text-[#9CA3AF] mt-12">
            Last reviewed June 2026 · Governed by the Australian Privacy Act 1988. The Centre honours data-protection rights for visitors worldwide.
          </p>
        </div>
      </section>
    </>
  );
}
